/** Formattazione condivisa. Niente numeri grezzi nella UI. */

export function money(value: number | string | null | undefined, currency = "EUR"): string {
  if (value === null || value === undefined) return "—";
  const n = typeof value === "string" ? Number(value) : value;
  if (Number.isNaN(n)) return "—";
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}

export function lots(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return "—";
  const n = typeof value === "string" ? Number(value) : value;
  return Number.isNaN(n) ? "—" : n.toFixed(2);
}

export function points(value: number | null | undefined): string {
  return value === null || value === undefined ? "—" : `${value.toLocaleString("it-IT")} pt`;
}

/** Le percentuali sono frazioni nel database: 0.06 si mostra come 6%. */
export function percent(fraction: number | string | null | undefined, digits = 1): string {
  if (fraction === null || fraction === undefined) return "—";
  const n = typeof fraction === "string" ? Number(fraction) : fraction;
  return Number.isNaN(n) ? "—" : `${(n * 100).toFixed(digits)}%`;
}

export function date(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
}

export function dateTime(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

/** Leva MT5 nella forma 1:500. */
export function leverage(value: number | null | undefined): string {
  return value === null || value === undefined ? "—" : `1:${value.toLocaleString("it-IT")}`;
}

/** Messaggi del motore come frase: iniziale maiuscola. Il testo resta quello del motore. */
export function sentence(text: string | null | undefined): string {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function signClass(n: number): string {
  return n > 0 ? "text-gain" : n < 0 ? "text-loss" : "text-muted";
}
